export const INFORME_STYLES = `
  /* Fuente Encode Sans para tablas */
  @import url('https://fonts.googleapis.com/css2?family=Encode+Sans:wght@400;600;700&display=swap');
  @page { size: A4 portrait; margin: 0; }
  *{ margin:0; padding:0; box-sizing:border-box; }

  body{ font-family: 'Encode Sans', Arial, Helvetica, sans-serif; background:#f4f4f4; padding:30px; color:#3c3c3b; }

  .page{ width:210mm; height:297mm; background:#fff; margin:auto; padding: 7mm 7mm 19.84px 7mm; box-shadow:0 0 12px rgba(0,0,0,.08); display:flex; flex-direction:column; }
  .page + .page{ margin-top:30px; }
  .page-break { page-break-before: always; break-before: page; }

  @media print {
    body { padding:0; background:transparent; }
    .page + .page { margin-top:0; }
  }

  .header{ padding-bottom:6px; margin-bottom:6px; }
  .header-top{ display:flex; justify-content:space-between; align-items:center; }
  .logo{ font-weight:bold; color:#002f87; font-size:18px; }
  .title{ text-align:center; font-size:18px; font-weight:bold; margin-top:8px; }
  .header-bottom{ display:flex; justify-content:space-between; font-size:12px; margin-top:8px; }

  .section-title{ background:#1a1a1a; color:#fff; padding:6px 10px; font-size:13px; font-weight:bold; }
  /* Contenedor de datos del empleador: solo borde inferior del bloque y del primer renglón (Razón social) */
  .info-box{ border:none; border-bottom:0.25px solid #262626; padding:2px; font-size:13px; margin-bottom:14px; }
  .info-box .rs{ border-bottom:0.25px solid #262626; padding-bottom:6px; margin-bottom:6px; }
  .info-row{ display:grid; grid-template-columns:1fr auto 1fr; align-items:center; margin-top:0; }
  .info-row .mid{ justify-self:center; }

  .cards{ display:grid; grid-template-columns:repeat(3,1fr); gap:5mm; }
  .card{ border:1px solid #d2d2d2; }
  .card table{ width:100%; border-collapse:collapse; font-size:8px; }
  /* Bordes tablas de indicadores */
  .card table, .card th, .card td { border:0.25px solid #262626; font-family:'Encode Sans', Arial, Helvetica, sans-serif; }
  .card th{ background:#d9d9d9; padding:6px; text-align:center; font-weight:600; }
  .card td{ padding:6px; font-weight:600; }
  /* Quitar borde superior (techo) en cada una de las 3 tablas de Indicadores */
  .cards .card table { border-top: 0 none; }
  .cards .card tr:first-child th,
  .cards .card tr:first-child td { border-top: 0 none; }

  .charts{ display:grid; grid-template-columns:1fr 1fr; gap:5mm; margin-top:5mm; }
  .chart{ border:1px solid #d2d2d2; }
  .chart-title{ background:#1a1a1a; color:#fff; padding:6px 10px; font-size:13px; font-weight:bold; }
  .chart-body{ display:block; padding:0; overflow:hidden; }
  .chart-caption{ display:flex; justify-content:space-between; font-size:9px; color:#555; padding:4px 8px 6px; border-top:1px solid #e0e0e0; }
  .chart-evolucion{ margin-top:5mm; border:none; height:412.82px; display:flex; flex-direction:column; overflow:hidden; }
  .chart-evolucion .chart-body{ flex:1; min-height:0; overflow:hidden; }
  .chart-evolucion .chart-body img{ width:100%; height:100%; display:block; object-fit:fill; }

  .table-section{ margin-top:5mm; }
  table.main{ width:100%; border-collapse:collapse; table-layout:fixed; font-size:8px; }
  /* Bordes tablas principales */
  table.main, table.main th, table.main td { border:0.25px solid #262626; font-family:'Encode Sans', Arial, Helvetica, sans-serif; }
  table.main th{ background:#D9D9D9; color:#3c3c3b; padding:6px; text-align:center; }
  table.main td{ padding:6px; }
  table.main tr:nth-child(even){ background:#f8f8f8; }

  /* Ranking CIE-10 */
  .rnk { width:100%; border-collapse:collapse; table-layout:fixed; font-size:8px; }
  /* Bordes ranking CIE-10 */
  .rnk, .rnk th, .rnk td { border:0.25px solid #262626; font-family:'Encode Sans', Arial, Helvetica, sans-serif; }
  .rnk th { background:#D9D9D9; color:#3c3c3b; padding:6px; text-align:left; }
  .rnk td { padding:6px; }
  .rnk tr:nth-child(even){ background:#f8f8f8; }

  /* No saltos de línea en celdas de tablas (con elipsis) */
  table.main th, table.main td,
  .rnk th, .rnk td,
  .card th, .card td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .footer{ margin-top:auto; display:flex; justify-content:space-between; align-items:flex-end; font-size:11px; color:#999; }

  /* Utilidades */
  td.r, th.r { text-align:right; }
  .empty-msg { padding:8px; font-family:'Encode Sans',Arial,Helvetica,sans-serif; font-weight:400; font-style:normal; font-size:8px; line-height:16px; letter-spacing:0.4px; text-align:center; vertical-align:middle; color:#3c3c3b; }
`
